export const createNotificationTabsConfig = (allCount: number, unreadCount: number) => [
  { id: "all" as const, notificationsCount: allCount, label: "All" },
  { id: "unread" as const, notificationsCount: unreadCount, label: "Unread" },
];

export type NotificationTabConfig = ReturnType<typeof createNotificationTabsConfig>[number];
